import React, { useEffect, useState } from "react";
import { BinIcon, EditPencilIcon } from "../../../../assets/images/svg/SvgIcon";
import Filter from "../../../common/Filter/Filter";
import CommonTable from "../../../common/ui/CommonTable/CommonTable";
import "./DesignManagement.scss";
import DeleteModal from "../../../common/ui/Modals/DeleteModal/DeleteModal";
import { useSelector } from "react-redux";
import {
  apiCallDelete,
  apiCallPatch,
  apiCallPost,
} from "../../../../axios/axios";
import {
  API_DATA_LIMIT,
  PAGES,
  PLACEHOLDER_TEXT,
} from "../../../../utils/constants";
import { checkUndefiendValue, getStatusLabel, truncateStringToWords } from "../../../../utils/utils";
import PaginationWrapper from "../../../common/ui/PaginationWrapper/PaginationWrapper";
import activeIcon from "../../../../assets/images/svg/user.svg";
import deleteicon from "../../../../assets/images/svg/delete.svg";
import EditIcon from "../../../../assets/images/svg/edit.svg";
// import activeIcon from "../../../../assets/images/svg/user-icon.svg";
import deactiveIcon from "../../../../assets/images/svg/blockuser.svg";
import DeActivateModal from "../../../common/ui/Modals/DeActivateModal/DeActivateModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSwitch from "../../../common/ui/Formik/CustomSwitch/CustomSwitch";

const DesignManagement = () => {
  // states
  const [designData, setDesignData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [itemToDelete, setItemToDelete] = useState("");
  const [showDeactivate, setShowDeactivate] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [status, setStatus] = useState(null);

  // hooks
  const { design } = useSelector((state) => state.filters);

  // get design
  const getDesignList = async () => {
    let payload = {
      search: design?.search || "",
    };
    let res = await apiCallPost(
      `/api/v1/design_management/${API_DATA_LIMIT}/${offset}`,
      payload,
      {},
      false,
      true
    );
    if (!res?.error) {
      setDesignData(res?.data);
    }
  };

  useEffect(() => {
    getDesignList();
  }, [design, offset]);

  useEffect(() => {
    if (design) {
      getDesignList();
      setOffset(1);
    }
  }, [design]);

  // delete design
  const deleteDesign = async () => {
    let res = await apiCallDelete(
      `/api/v1/design_management/${itemToDelete}`,
      {},
      {},
      true,
      true
    );
    if (!res?.error) {
      setItemToDelete("");
      getDesignList();
    }
  };
  const deleteHandler = (item) => setItemToDelete(item);

  const submitCallback = () => {
    deleteDesign();
  };
  const changeStatus = async (data) => {
    let payload = {
      // id: data?.userId,
      status: data?.selectedStatus,
    };
    const userId = data?.userId;
    let res = await apiCallPatch(
      `/api/v1/design_management/${userId}`,
      payload,
      {},
      true,
      true
    );
    if (!res?.error) {
      getDesignList();
      {
        setShowDeactivate(false);
      }
    }
  };

  const statusChangeHandler = (status, userId) => {
    let blockAction = status === status ? true : false;
    setStatus(status);
    let data = {
      selectedStatus: status,
      userId: userId,
    };
    setSelectedUser(data);
    if (blockAction) {
      setShowDeactivate(true);
    } else {
      changeStatus(data);
    }
  };

  return (
    <div className="Blog_management">
      <Filter
        isSearch
        isButton
        title={<p>Add Design</p>}
        to={"/admin/create_design"}
        page={PAGES.design}
        placeholdertext={PLACEHOLDER_TEXT.title}
      />
      <CommonTable className="user_management_table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Gender</th>
            <th>Size</th>
            <th>Description</th>
            <th>Status</th>
            <th style={{ width: "330" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {designData?.count > 0 ? (
            designData?.rows?.map((item, index) => (
              <tr key={index}>
                <td>{offset * 10 - 10 + index + 1}</td>
                <td>{checkUndefiendValue(item?.name, "--")}</td>
                <td>{checkUndefiendValue(item?.category, "--")}</td>
                <td>{checkUndefiendValue(item?.size, "--")}</td>
                <td>
                  <OverlayTrigger
                    placement="left"
                    overlay={
                      <Tooltip id="tooltip" style={{ fontSize: 14 }}>
                        {checkUndefiendValue(item.description, "--")}
                      </Tooltip>
                    }
                  >
                    <p className="mb-3  text-wrap">
                      {truncateStringToWords(checkUndefiendValue(item.description, "--") , 5)}
                    </p>
                  </OverlayTrigger>
                </td>
                <td>
                  {checkUndefiendValue(
                    item?.status === "ACTIVE" ? "Active" : "Deactive",
                    "--"
                  )}
                </td>
                <td>
                  <div className="commonBtnsGroup">
                    <span
                      onClick={() => {
                        let status =
                          item?.status === "BLOCKED" ? "ACTIVE" : "BLOCKED";
                        statusChangeHandler(status, item?.id);
                      }}
                    >
                      <CustomSwitch
                        checked={item?.status === "BLOCKED"}
                        onChange={(newStatus) => {
                          let status =
                            newStatus === true ? "BLOCKED" : "ACTIVE";
                          statusChangeHandler(status, item?.id);
                        }}
                      />
                    </span>
                    <span onClick={() => deleteHandler(item?.id)}>
                      <img src={deleteicon} alt="icon" />
                    </span>
                    <span>
                      <Link
                        to="/admin/edit_design_management"
                        state={{ data: item }}
                      >
                        <img src={EditIcon} alt="icon" />
                      </Link>
                    </span>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7} style={{ textAlign: "center" }}>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </CommonTable>
      {/* <UpdateBlogModal show={showUpdate} onHide={() => setShowUpdate(false)} /> */}

      <DeleteModal
        Title={"Are you sure you want to delete this design ?"}
        show={itemToDelete}
        onHide={() => setItemToDelete("")}
        onSubmit={submitCallback}
      />

      {showDeactivate && (
        <DeActivateModal
          Title={`Are you sure you want to ${
            status === "BLOCKED" ? "deactive" : "active"
          } this design ?`}
          show={showDeactivate}
          onHide={() => setShowDeactivate(false)}
          heading="Deactivate User"
          selectedUser={selectedUser}
          onSubmit={(data) => {
            changeStatus(data);
          }}
        />
      )}

      {/* {designData?.count > API_DATA_LIMIT && ( */}
      <div className="page_nation">
        <PaginationWrapper
          limit={API_DATA_LIMIT}
          page={offset}
          count={designData?.count}
          onChange={(e) => setOffset(e)}
        />
      </div>
      {/* // )} */}
      {/* <div className="page_nation">
        <CustomPagination />
      </div> */}
    </div>
  );
};

export default DesignManagement;
